<template>
  <div>
    <file-uploader :compMode="compMode" entite="Investment"></file-uploader>
        
    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-briefcase"></i> 
        <span v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY">{{ $t('project.investment.create.title') }}</span>
        <span v-if="compMode == CRUDMODE.UPDATE">{{ $t('project.investment.edit.title') }}</span>
        <span v-if="compMode == CRUDMODE.READ">{{ $t('project.investment.view.title') }}</span>
      </div>
      <div class="card-body">

        <errorMessage v-bind:message="error"></errorMessage>

        <form @keyup.enter="createEntity">

          <create-investment ref="createInvestment" :investment="entity" v-on:userSelected="userSelected" v-on:projectSelected="projectSelected" :compMode="compMode">
            <div slot="project">

              <div class="row">
                <div class="form-group col-md-2">
                  <label for="roundInput">{{ $t('project.investment.form.company.round') }}*</label>
                  <input maxlength="100" v-model.trim="entity.round" v-validate="'required'" type="number" 
                      class="form-control" id="roundInput" name="round" /> 
                  <span class="text-danger" v-if="errors.has('round')">{{ errors.first('round') }}</span>
                </div>

                <div class="form-group col-md-2">
                    <label for="revenuInput">{{ $t('project.investment.form.company.revenu') }}</label>
                    <div class="col-9">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="revenuInput"  value="1" class="custom-control-input" id="aLaCarteInput" 
                              v-model="entity.income" >
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-label">Oui</span>
                        </label>
                    </div>
                </div>

                <div class="form-group col-md-2" v-if="entity.project != null">
                    <label for="aLaCarteInput">{{ $t('project.company.form.aLaCarte') }}</label>
                    <div class="col-9">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="aLaCarte" disabled value="1" class="custom-control-input" id="aLaCarteInput" 
                              v-model="entity.project.aLaCarte" >
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-label">Oui</span>
                        </label>
                    </div>
                </div>

                <div class="form-group col-md-3" v-if="entity.project != null">
                  <label for="originInput">{{ $t('project.company.form.finances.origin') }}*</label>
                  <select v-model="entity.project.origin" disabled class="form-control" id="originInput" >
                    <option v-for="s in origins" :value="s.item1" :key="s.item1" >{{s.item2}}</option>
                  </select>
                </div>

                <div class="form-group col-md-3" v-if="entity.project != null">
                  <label for="statusInput">{{ $t('project.form.status') }}*</label>
                  <select v-model="entity.project.companyStatus" disabled class="form-control" id="statusInput">
                    <option v-for="s in companyStatuses" :value="s.item1" :key="s.item1">{{s.item2}}</option>
                  </select>
                </div>
                
            </div>

          </div>

          </create-investment>

          <div class="card font-weight-bold text-uppercase bg-warning mb-3" v-if="entity.imported && compMode == CRUDMODE.UPDATE">
            <div class="card-body">
              <label class="custom-control custom-checkbox" >
                  <input type="checkbox" name="lead"
                    value="1" class="custom-control-input" id="removeImportedFlag" v-model="entity.removeImportedFlag" >
                  <span class="custom-control-indicator"></span>
                  <span class="custom-control-label">{{ $t('removeImportedFlag') }}</span>
              </label>
            </div>
          </div>

          <a @click="createEntity" v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY" id="addButton" class="btn btn-primary">
            {{ $t('form.create_button') }}
          </a>

          <a @click="editEntity" v-if="compMode == CRUDMODE.UPDATE" id="editButton" class="btn btn-primary">
            {{ $t('form.edit_button') }}
          </a>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  InvestmentServiceClient,
  CompanyInvestmentServiceClient,
  CompanyServiceClient,
  ProjectServiceClient,
  CompanyInvestmentDto,
  ProjectDto,
  EntrepriseDto,
  UserDto,
} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import ErrorMessage from '../ErrorMessage.vue'

import CrudMixin from '../../shared/Mixin/CrudMixin'
import moment from 'moment'
import Enum from '../../shared/enum'
import CreateInvestment from './CreateInvestment'

export default {
  name: 'CreateCompanyInvestment',
  mixins: [CrudMixin],
  data() {
    let dto = new CompanyInvestmentDto()
    dto.init({investmentType: 1})
    dto.project = new ProjectDto()
    dto.project.entreprise = new EntrepriseDto()
    dto.investmentValues = []
    dto.investmentProcessus = []

    return {
      user: {},
      ready: false,
      entity: dto,
      companyStatuses: [],
      origins: [],
    }
  },
  methods: {
    userSelected: function(user) {
      let localUser = user
      localUser.creationTime = moment(localUser.creationTime._i)

      this.user = UserDto.fromJS(localUser)
    },
    projectSelected: function(project) {
      let entityService = ServiceFactory.create(CompanyInvestmentServiceClient)
      entityService
        .getRoundForCompany(project.id)
        .then(res => {
          this.entity.round = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    manageEntity: function() {
      let cleanEntity = this.cleanFields(this.entity)

      if (this.compMode == Enum.Mode.CREATE) {
        cleanEntity.project = null
        cleanEntity.user = null
      } else {
        cleanEntity.project = ProjectDto.fromJS(cleanEntity.project)

        if (cleanEntity.user != null && this.user.firstName !== undefined) {
          cleanEntity.user = this.user
        }
      }

      if (cleanEntity.investmentProcessus != null) {
        cleanEntity.investmentProcessus = _.orderBy(cleanEntity.investmentProcessus, 'asc')
        for (var ix = 0; ix < cleanEntity.investmentProcessus.length; ix++) {
          let nextProcess = cleanEntity.investmentProcessus[ix + 1]
          if (nextProcess != null) {
            let dateNextProcess =
              nextProcess.deposit != null
                ? nextProcess.deposit
                : nextProcess.presentation != null
                  ? nextProcess.presentation
                  : nextProcess.nextMeeting != null
                    ? nextProcess.nextMeeting
                    : nextProcess.signatureTS != null
                      ? nextProcess.signatureTS
                      : nextProcess.abandonment != null
                        ? nextProcess.abandonment
                        : nextProcess.debutVD != null
                          ? nextProcess.debutVD
                          : nextProcess.endVD != null
                            ? nextProcess.endVD
                            : nextProcess.closing != null
                              ? nextProcess.closing
                              : nextProcess.lastCall != null
                                ? nextProcess.lastCall
                                : nextProcess.appelInfo != null
                                  ? nextProcess.appelInfo
                                  : nextProcess.rencontreInfo != null ? nextProcess.rencontreInfo : null

            cleanEntity.investmentProcessus[ix].lastProcess = dateNextProcess
          }
        }
      }

      if (cleanEntity.investmentValues != null) {
        for (var ix = 0; ix < cleanEntity.investmentValues.length; ix++) {
          if (cleanEntity.investmentValues[ix].type == 2 && cleanEntity.investmentValues[ix].member != undefined) {
            cleanEntity.investmentValues[ix].memberId = cleanEntity.investmentValues[ix].member.id
            cleanEntity.investmentValues[ix].partnerId = null
          } else if (cleanEntity.investmentValues[ix].type == 1 && cleanEntity.investmentValues[ix].partner != undefined) {
            cleanEntity.investmentValues[ix].partnerId = cleanEntity.investmentValues[ix].partner.id
            cleanEntity.investmentValues[ix].memberId = null
          }
          cleanEntity.investmentValues[ix].member = null
          cleanEntity.investmentValues[ix].partner = null
        }
      }

      return cleanEntity
    },
    createEntity: function() {
      let self = this
      this.$validator
        .validateAll()
        .then(result => {
          if (result && self.ready) {
            let entityService = ServiceFactory.create(CompanyInvestmentServiceClient)

            entityService
              .create(self.manageEntity())
              .then(res => this.persistFiles(res.id))
              .then(res => {
                this.$swal('Succès', this.$t('project.investment.create.succes'), 'success')
                this.$router.push({path: '/projects/investments'})
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            console.log('error: ' + self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    editEntity: function() {
      let self = this
      this.$validator
        .validateAll()
        .then(result => {
          if (result && this.ready) {
            let entityService = ServiceFactory.create(CompanyInvestmentServiceClient)

            entityService
              .update(self.manageEntity())
              .then(res => this.persistFiles(res.id))
              .then(res => {
                self.$swal('Succès', this.$t('project.investment.edit.succes'), 'success')
                self.$router.push({path: '/projects/investments'})
              })
              .catch(err => {
                self.processError(err, self)
              })
          } else {
            console.log(self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    sortValues: function(list) {
      return _.sortBy(list, function(x) {
        return [x.partner, x.member, x.partner != null ? x.partner.name : '', x.member != null ? x.member.familyName : '']
      })
    },
    fetchData: function() {
      let service = ServiceFactory.create(InvestmentServiceClient)
      let EntityService = ServiceFactory.create(CompanyInvestmentServiceClient)
      let companyService = ServiceFactory.create(CompanyServiceClient)
      let projectService = ServiceFactory.create(ProjectServiceClient)

      let self = this
      let promisseAll

      let getOrigin = companyService.getOrigin()
      let getCompanyStatus = projectService.getCompanyStatus()

      getCompanyStatus
        .then(res => {
          self.companyStatuses = res
        })
        .catch(err => {
          console.log(err)
        })
      getOrigin
        .then(res => {
          self.origins = res
        })
        .catch(err => {
          console.log(err)
        })

      if (this.compMode != Enum.Mode.CREATE) {
        let getEntity = EntityService.get(this.$route.params.id)
        getEntity
          .then(res => {
            self.entity = res

            companyService.get(self.entity.project.id).then(res => {
              self.entity.project = res
            })

            if (self.entity.investmentValues == null) {
              self.entity.investmentValues = []
            } else {
              self.entity.investmentValues = this.sortValues(self.entity.investmentValues)
            }

            if (self.entity.investmentProcessus == null) {
              self.entity.investmentProcessus = []
            }

            self.checkCopyMode(self.entity)
          })
          .catch(err => {
            console.log(err)
          })

        promisseAll = Promise.all([getEntity])
      } else {
        promisseAll = Promise.all([])
      }

      promisseAll.then(v => {
        self.ready = true
      })
    },
  },
  components: {
    errorMessage: ErrorMessage,
    CreateInvestment,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.btn-primary {
  color: #fff !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Investment/CreateCompanyInvestment.vue